import { render } from "./BarChartI.vue?vue&type=template&id=81eacf18&scoped=true"
import script from "./BarChartI.vue?vue&type=script&lang=ts"
export * from "./BarChartI.vue?vue&type=script&lang=ts"

import "./BarChartI.vue?vue&type=style&index=0&id=81eacf18&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-81eacf18"

export default script